import { UseFormRegister, FieldValues, FieldErrors } from "react-hook-form";
import { Rules } from "../../types/integrations";
import { Input } from "../ui/input";
import { Field, FieldLabel, FieldError } from "../ui/field";

interface NumberInputProps {
  label: string;
  placeholder: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  rules: Rules;
  errors: FieldErrors<FieldValues>;
  min?: number;
  max?: number;
  step?: number;
  value?: number;
}

export const FormNumberInput = ({
  label,
  placeholder,
  name,
  register,
  rules,
  errors,
  min,
  max,
  step,
  value
}: NumberInputProps) => {
  return (
    <Field>
      <FieldLabel htmlFor={name}>
        {label}
      </FieldLabel>
      <Input
        id={name}
        type="number"
        placeholder={placeholder ?? ''}
        {...register(name, rules)}
        min={min}
        max={max}
        step={step}
        defaultValue={value}
        aria-invalid={!!errors[name]}
      />
      {errors[name] && (
        <FieldError>{`${errors[name]?.message}`}</FieldError>
      )}
    </Field>
  );
};
